<template>
    <div>
        <!-- Banner de Mantenimiento -->
        <div class="maintenance-banner-content" v-if="showMaintenanceBanner">
            <div class="maintenance-content">
                <div class="maintenance-icon">
                    <i class="fa fa-tools"></i>
                </div>
                <div class="maintenance-text">
                    <span class="maintenance-title">Labores de Mantenimiento</span>
                    <span class="maintenance-description">Estamos presentando intermitencia, en caso de novedades comunicate por el canal de tickets</span>
                </div>
                <button class="maintenance-close" @click="dismissBanner">
                    <i class="fa fa-times"></i>
                </button>
                <button class="maintenance-details" @click="openMaintenanceModal">
                    <i class="fa fa-info-circle"></i>
                </button>
            </div>
        </div>

        <!-- Modal de Mantenimiento -->
        <b-modal v-model="showMaintenanceModal"
                 title="Información de Mantenimiento"
                 ok-only
                 ok-title="Entendido"
                 ok-variant="primary"
                 centered
                 size="md">
            <div class="maintenance-modal-content">
                <div class="text-center mb-3">
                    <i class="fa fa-tools soluquim-primary" style="font-size: 3rem;"></i>
                </div>
                <h5 class="text-center mb-3 soluquim-primary">Notificación de servicio</h5>
                <p class="text-muted text-center mb-4">
                    Nuestro software está presentando intermitencias temporales.
                    Estamos trabajando en la solución y estimamos un tiempo de ajuste de 8 horas.
                </p>
                <div class="alert alert-soluquim" role="alert">
                    <i class="fa fa-exclamation-triangle mr-2"></i>
                    Si requieres atención prioritaria, por favor comunícate con el ingeniero asignado a tu cuenta o comunícate por el canal de tickets.
                </div>
                <div class="text-center">
                    <div class="text-muted">Agradecemos tu comprensión.</div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'MaintenanceBanner',
    data() {
        return {
            showMaintenanceBanner: true,
            showMaintenanceModal: false
        };
    },
    mounted() {
        this.showMaintenanceBanner = false;
        this.showMaintenanceModal = false;
    },
    methods: {
        dismissBanner() {
            this.showMaintenanceBanner = false;
            this.showMaintenanceModal = false;
        },
        openMaintenanceModal() {
            this.showMaintenanceModal = true;
        },
    }
};
</script>

<style scoped>
/* Estilos del Banner de Mantenimiento - Dentro del Contenido */
.maintenance-banner-content {
    background: linear-gradient(135deg, #058580 0%, #20a8d8 100%);
    color: white;
    box-shadow: 0 4px 20px rgba(5, 133, 128, 0.25);
    border-radius: 8px;
    margin: 0 0 20px 0;
    transform: translateY(-20px);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.maintenance-banner-content.show {
    transform: translateY(0);
    opacity: 1;
}

.maintenance-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 20px;
    position: relative;
}

.maintenance-icon {
    margin-right: 16px;
    opacity: 0.95;
}

.maintenance-icon i {
    font-size: 20px;
    animation: pulse-soluquim 2s infinite;
    color: rgba(255, 255, 255, 0.9);
}

@keyframes pulse-soluquim {
    0% {
        opacity: 0.9;
        transform: scale(1);
    }
    50% {
        opacity: 0.7;
        transform: scale(1.05);
    }
    100% {
        opacity: 0.9;
        transform: scale(1);
    }
}

.maintenance-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: center;
}

.maintenance-title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 2px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

.maintenance-description {
    font-size: 14px;
    opacity: 0.9;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
}

.maintenance-close, .maintenance-details {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    transition: all 0.3s ease;
    opacity: 0.85;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
}

.maintenance-close:hover, .maintenance-details:hover {
    background: rgba(255, 255, 255, 0.15);
    opacity: 1;
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.maintenance-close i, .maintenance-details i {
    font-size: 14px;
}

.maintenance-modal-content {
    padding: 1rem;
}

/* Clases de colores Soluquim */
.soluquim-primary {
    color: #058580 !important;
}

.alert-soluquim {
    background-color: rgba(5, 133, 128, 0.1);
    border: 1px solid rgba(5, 133, 128, 0.3);
    color: #058580;
}

.alert-soluquim i {
    color: #058580;
}

/* Responsive Design */
@media (max-width: 768px) {
    .maintenance-content {
        padding: 2px 16px;
    }

    .maintenance-icon {
        margin-right: 12px;
    }

    .maintenance-icon i {
        font-size: 18px;
    }

    .maintenance-title {
        font-size: 15px;
    }

    .maintenance-description {
        font-size: 13px;
    }

    .maintenance-close, .maintenance-details {
        width: 28px;
        height: 28px;
    }
}

@media (max-width: 480px) {
    .maintenance-content {
        padding: 2px 14px;
    }

    .maintenance-text {
        text-align: left;
    }

    .maintenance-title {
        font-size: 14px;
    }

    .maintenance-description {
        font-size: 12px;
    }

    .maintenance-icon {
        margin-right: 10px;
    }

    .maintenance-icon i {
        font-size: 16px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .maintenance-banner-content {
        transition: none;
    }

    .maintenance-icon i {
        animation: none;
    }
}
</style>
